import { type CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import { CellDatetime } from 'src/registry/components/table';
import { Badge } from 'src/registry/ui/Badge';
import { generalMessages } from 'src/utils/messages';

function CellExpiration<TData, TValue>({ getValue, ...props }: CellContext<TData, TValue>) {
    const value = getValue();
    if (value == null) return null;

    const date = new Date(value.toString());

    if (date < new Date()) {
        return (
            <Badge theme="red">
                <FormattedMessage {...generalMessages.expired} />
            </Badge>
        );
    }

    return <CellDatetime {...props} getValue={getValue} />;
}

export { CellExpiration };
